<span [ngClass]="getStatusCssClass(status)">
  {{ 'proccessStatus.' + status | translate }}
</span>
<mat-progress-bar *ngIf="status === ProcessStatus.Processing" mode="indeterminate"></mat-progress-bar>
